// Maps settings preference keys to the notification type strings stored in the DB
export const NOTIFICATION_TYPE_MAP = {
  tasks_reviews: ['task_assigned', 'review_phase_change', 'review_returned', 'qa_checklist_assigned'],
  drawings_revisions: ['drawing_revision'],
  design_changes: ['design_change_created', 'design_change_closed'],
  permits: ['permit_approved', 'permit_expired'],
  transmittals: ['transmittal_issued', 'transmittal_closed'],
};

export function getEnabledNotificationTypes(notificationPreferences = {}) {
  return Object.entries(NOTIFICATION_TYPE_MAP)
    .filter(([key]) => notificationPreferences[key] !== false)
    .flatMap(([, types]) => types);
}

export const DEFAULT_PREFERENCES = {
  theme: 'dark',
  compact_mode: false,
  reduced_motion: false,
  default_landing_page: 'dashboard',
  notifications: {
    tasks_reviews: true,
    drawings_revisions: true,
    design_changes: true,
    permits: true,
    transmittals: true,
  },
};

export function normalizePreferences(rawPreferences = {}) {
  const notifications = {
    tasks_reviews: true,
    drawings_revisions: true,
    design_changes: true,
    permits: true,
    transmittals: true,
    ...(rawPreferences?.notifications || {}),
  };

  return {
    ...DEFAULT_PREFERENCES,
    ...rawPreferences,
    notifications,
  };
}

export function buildPreferencesPayload(preferences) {
  return {
    preferences: normalizePreferences(preferences),
    updated_at: new Date().toISOString(),
  };
}
